import axiosBaseApi from '../common/lib/axiosBaseApi';
import { Referral } from '@/services/referrals/referralsServicesTypes';

export const getReferrals = () => {
  return axiosBaseApi.get<Referral[]>(`/v1/user/referrals`);
};
